import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useApiClient } from '../../hooks/use-api-client.js';
import { pushToast } from '../app/toast-store.js';
import { useGlobalErrorShake } from '../../components/ui/error-shake/error-shake-context.js';

export function BillingAddressSection() {
  const { t } = useTranslation('settings');
  const { fetchApi } = useApiClient();
  const [portalLoading, setPortalLoading] = useState(false);
  const shake = useGlobalErrorShake();

  async function handleManageBilling() {
    setPortalLoading(true);
    try {
      const res = await fetchApi('/v1/billing/portal', { method: 'POST' });
      if (!res.ok) {
        pushToast({ tone: 'error', title: t('billing.errorToast') });
        shake();
        return;
      }
      const body = await res.json();
      const url = (body as { data?: { url?: string } })?.data?.url;
      if (url && url.startsWith('https://')) {
        window.location.href = url;
      } else {
        pushToast({ tone: 'error', title: t('billing.errorToast') });
        shake();
      }
    } catch {
      pushToast({ tone: 'error', title: t('billing.errorToast') });
      shake();
    } finally {
      setPortalLoading(false);
    }
  }

  return (
    <section aria-labelledby="settings-billing-heading" className="mb-2">
      <h2 id="settings-billing-heading" className="text-h2 font-semibold text-primary mb-4">
        {t('billing.heading')}
      </h2>
      <p className="text-body text-secondary mb-4">{t('billing.description')}</p>
      <button
        type="button"
        onClick={handleManageBilling}
        disabled={portalLoading}
        data-testid="billing-portal-button"
        className="btn-press rounded px-4 py-2 text-sm font-medium bg-white/10 text-primary hover:bg-white/15 transition-colors cursor-pointer disabled:opacity-50"
      >
        {portalLoading ? t('billing.loading') : t('billing.manage')}
      </button>
    </section>
  );
}
